import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=4b62873c&scoped=true&"
var script = {}
import style0 from "./Progress.vue?vue&type=style&index=0&id=4b62873c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b62873c",
  null
  
)

export default component.exports